import { render, staticRenderFns } from "./DocumentImageInput.vue?vue&type=template&id=6a812733"
import script from "./DocumentImageInput.vue?vue&type=script&lang=ts"
export * from "./DocumentImageInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports